// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ICOAbPFXszIRHpG6Ku9l {
  width: 100px !important;
  height: 100px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Equipments/index.module.less"],"names":[],"mappings":"AAIA;EACE,uBAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF","sourcesContent":[".container {\n\n}\n\n.equipmentImg {\n  width: 100px !important;\n  height: 100px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentImg": `ICOAbPFXszIRHpG6Ku9l`
};
export default ___CSS_LOADER_EXPORT___;
